<template>
   <div data-cy="rich-text-block">
      <RichTextRenderer class="blockQuestionSubtitle" :document="props.block.data" />
   </div>
</template>

<script setup lang="ts">
import type { RichText } from "@/types";
import type { AnswerResp } from "@/data/api-layer/answersApi";
import type { FlowselBlock } from "@/components/flowsel/flowsel.type";

export interface RichTextBlock extends FlowselBlock {
   data: RichText;
}

interface Props {
   block: RichTextBlock;
   userBlockAnswer: AnswerResp | null;
   showBlockErrors: boolean;
}

// declarations
// -----------------------------------------
const emit = defineEmits(["update-valid", "update-answer"]);
const props = defineProps<Props>();

// We need to set 'valid' to true, as no answer will be entered
emit("update-valid", true);
</script>

<style scoped lang="scss"></style>
